/**
 * 模版内容定义和同步
 * @author chenqunfeng, VenDream
 * @since 18/06/07
 */

import store from 'store';
import Stat from '@fe/common/lib/stat';
import { cleanObj, sendStat } from 'utils/common';
import * as ajax from '@fe/common/lib/ajax';
import ACTIONS from 'constants/action.json5';
import VARIABLE from 'constants/variable.json5';
import STAT_PARAMS from 'constants/stat-params.json5';
import { parse } from '@fe/common/lib/query-string';
import localCache from 'utils/searchCache';
import { getOpenZoneTplList, getOrgZoneTplList } from 'api/store';
let filterItemsArr = [];
let filterItemsEle;
/**
 * 根据id设置模版内容
 * 目前能获取的模版类别为两类:
 * 1、H5模版,一页模版,一视模版,我的收藏
 * 2、本地导出作品
 * 不能获取的为类别有两类
 * 1、企业专区模版
 * 2、我的模版
 * @param {object} data
 */
export function setTemplate(data) {
  return async dispatch => {
    try {
      const { id, userId, organizeId, category } = data;
      let url;
      let template;
      let params;

      if (category === VARIABLE.LOCAL_TEMPLATE) {
        url = `/api/store/template/template/localTemplate`;
        params = cleanObj({
          id,
        });
      } else if (category === VARIABLE.RP_GAME) {
        url = `/api/store/template/template/gameTemplate`;
        params = cleanObj({
          id,
          userId,
          organizeId,
        });
      } else {
        url = `/api/store/template/template`;
        params = cleanObj({
          id,
          userId,
          organizeId,
          category,
        });
      }

      template = await ajax.get(url, params);
      dispatch({
        type: ACTIONS.SET_TEMPLATE,
        data: {
          ...template,
          status: VARIABLE.SUCCESS,
        },
      });

      return template;
    } catch (err) {
      const { id } = data;

      dispatch({
        type: ACTIONS.SET_TEMPLATE_ERROR,
        data: {
          id,
          status: VARIABLE.ERROR,
        },
      });

      return {
        id,
        status: VARIABLE.ERROR,
      };
    }
  };
}

/**
 * 获取模版数据
 * @param {Object} opts 请求参数
 *
 * opts = {
 *  category,   // 当前分类
 *  keywords,   // 搜索关键词
 *  filterItems,// 筛选条件组合
 *  pageNo,     // 分页页码
 *  pageSize,   // 分页大小
 *  userId,     // 用户ID
 *  organizeId, // 企业ID
 *  filterKey,   // 免费模板页-筛选条件
 * }
 */
export function getStoreTpls(opts) {
  const {
    category,
    filterItems,
    pageNo,
    hidePayTemplate,
    filterKey,
    scrollId,
    loadType,
  } = opts;
  const api = '/api/store/template/tpls';
  return async dispatch => {
    function getTplsSucceed(tpls, totalRecords) {
      dispatch({
        type: ACTIONS.GET_TPLS_SUCCEED,
        payload: {
          category,
          tpls,
          totalRecords,
          hidePayTemplate,
          scrollId,
          loadType,
        },
      });
      if (filterKey) {
        dispatch({
          type: ACTIONS.GET_FILTERS_TPLS_SUCCEED,
          payload: {
            tpls,
            filterKey,
            loadType,
          },
        });
      }
    }

    try {
      // 请求中...
      dispatch({ type: ACTIONS.GET_TPLS_ING });

      // 获取数据
      opts = cleanObj(opts);
      if (typeof filterItems !== 'string') {
        opts.filterItems = { mostHot: true, ...filterItems };
        opts.mostHot = opts.filterItems.mostHot;
        delete opts.filterItems.mostHot;
        let filterArr = [];
        for (const value of Object.values(opts.filterItems)) {
          filterArr.push(value);
        }
        opts.filterItems = JSON.stringify(filterArr);
      }
      if (
        category === 'ENTERPRISE' ||
        category === 'VIP' ||
        category === 'MY_TPL'
      ) {
        opts.filterItems = JSON.stringify({ mostHot: true, ...filterItems });
      }
      filterItemsArr = JSON.parse(opts.filterItems);
      delete opts.loadType;
      const data = await ajax.get(api, opts);
      if (data.data.length === 0 && Array.isArray(filterItemsArr)) {
        let len = filterItemsArr.length;
        filterItemsEle = filterItemsArr[len - 1];
      }
      if (
        Array.isArray(filterItemsArr) &&
        filterItemsArr.includes(filterItemsEle)
      ) {
        data.data = [];
      }
      // 没有数据，小游戏暂不支持分页
      if (data.data) {
        if (category === VARIABLE.SEARCH) {
          setSearchTemplatescrollId(data);
        }
        if (!data.data.length) {
          if (+pageNo === 1) {
            // 第1页就没有数据表示该分类下无数据
            getTplsSucceed([], 0);
          } else if (+pageNo > 1) {
            // 后面页没有数据表示该分类的数据已加载完
            dispatch({ type: ACTIONS.GET_TPLS_ENDED });
          }
        } else {
          // 正常获取到数据
          getTplsSucceed(data.data, data.totalRecords);
        }
      } else {
        getTplsSucceed(data);
      }

      return data;
    } catch (e) {
      console.error(e);
      // 请求出错
      dispatch({ type: ACTIONS.GET_TPLS_FAILED });

      return null;
    }
  };
}

// 清空模版数据
export function clearStoreTpls() {
  return {
    type: ACTIONS.CLEAR_STORE_TPLS,
  };
}

/**
 * 设置搜索页 当前搜索引擎缓存页Id
 */
export function setSearchTemplatescrollId(data) {
  if (data && data.scrollId) {
    // 更新缓存
    localCache.set({
      version: localCache.version,
      expiredAt: new Date().getTime() + localCache.duration,
      data: data.scrollId,
    });
  }
}

// 设置模版收藏状态
export function setTplCollectionStatus(
  userId,
  organizeId,
  tplId,
  isCollectionTpl
) {
  const api = '/api/store/template/collection';

  // 统计收藏按钮点击量
  if (isCollectionTpl) {
    submitCollectionStat(tplId);
  }

  return async dispatch => {
    try {
      const data = await ajax.post(
        api,
        cleanObj({
          userId,
          organizeId,
          tplId,
          isCollectionTpl,
        })
      );

      if (+data.code === 200) {
        dispatch({
          type: ACTIONS.SET_TPL_COLLECTION_STATUS,
          payload: { tplId, isCollectionTpl },
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
}

// 统计收藏按钮点击量
function submitCollectionStat(tplId) {
  const { storeTabs, storeTpls } = store.getState();
  const { activeIndex, tabs } = storeTabs;
  const tabIndex = tabs.findIndex(n => n.index === activeIndex);
  const category = tabs[tabIndex === -1 ? 0 : tabIndex].name;
  const statData = {
    id: 'web_mobanmarket_favorite_click',
    tplid: tplId,
    clickfrom: STAT_PARAMS.TPL_CATEGORY[category],
  };

  // 判断触发源是否为搜索结果页的推荐模版
  if (
    category === VARIABLE.SEARCH &&
    storeTpls[VARIABLE.RECOMMEND].length > 0
  ) {
    statData.clickfrom = '1';
  }

  // 判断触发源是否为专题详情页
  let { id } = parse(location.search);
  if (id) {
    statData.clickfrom = '8';
  }

  sendStat('RP_STORE', '模版市场', '收藏模版', Stat.ACTION_CLICK, statData);
}

// 设置海报尺寸弹框显隐
export function togglePosterModal(flag) {
  return {
    type: ACTIONS.TOGGLE_POSTER_MODAL,
    data: flag,
  };
}

// 获取企业专区\平台专区模板数据
export function getSpecialZoneTpls(opts) {
  const {
    category,
    pageNo,
    pageSize,
    filters,
    hidePayTemplate,
    filterKey,
    scrollId,
  } = opts;

  const isOpenZone = category === VARIABLE.OPENZONE;
  const api = isOpenZone ? getOpenZoneTplList : getOrgZoneTplList;

  return async dispatch => {
    function getTplsSucceed(tpls, totalRecords) {
      dispatch({
        type: ACTIONS.GET_TPLS_SUCCEED,
        payload: {
          category,
          tpls,
          totalRecords,
          hidePayTemplate,
          scrollId,
        },
      });
      if (filterKey) {
        dispatch({
          type: ACTIONS.GET_FILTERS_TPLS_SUCCEED,
          payload: {
            tpls,
            filterKey,
          },
        });
      }
    }
    // 获取数据
    try {
      // 请求中...
      dispatch({ type: ACTIONS.GET_TPLS_ING });
      const data = await api({
        pageNo,
        pageSize,
        hidePayTemplate,
        scrollId,
        ...filters,
      });
      const list = isOpenZone ? data.data : data.records;
      const total = isOpenZone ? data.totalRecords : data.total;
      if ((Array.isArray(list) && list.length < 1) || !list) {
        if (+pageNo === 1) {
          // 第1页就没有数据表示该分类下无数据
          getTplsSucceed([], 0);
        } else if (+pageNo > 1) {
          // 后面页没有数据表示该分类的数据已加载完
          dispatch({ type: ACTIONS.GET_TPLS_ENDED });
        }
      } else {
        // 正常获取到数据
        getTplsSucceed(list || [], total);
      }
      return data;
    } catch (e) {
      console.error(e);
      // 请求出错
      dispatch({ type: ACTIONS.GET_TPLS_FAILED });

      return null;
    }
  };
}
